interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  light?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, align = "left", light = false }: SectionHeadingProps) {
  return (
    <div className={align === "center" ? "text-center" : ""}>
      {eyebrow ? (
        <span
          className={
            "inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold tracking-widest " +
            (light
              ? "border-white/25 bg-white/10 text-white/90"
              : "border-primary-200 bg-primary-50 text-primary-700")
          }
        >
          <i className="ri-sparkling-2-fill text-[13px]" aria-hidden="true"></i>
          {eyebrow}
        </span>
      ) : null}
      <h2
        className={
          "mt-4 font-heading text-2xl md:text-4xl font-black leading-snug tracking-tight " +
          (light ? "text-white" : "text-foreground-950")
        }
      >
        {title}
      </h2>
      {desc ? (
        <p className={"mt-3 max-w-2xl text-sm md:text-base leading-relaxed " + (align === "center" ? "mx-auto " : "") + (light ? "text-white/75" : "text-foreground-600")}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}